<div class="container-fluid" style="">
  <div class="stockWrapper">
    <div class="row">
    
      <div class="col-lg-1"></div>
      <div class="col-lg-10">

        <div class="card">
          <div class="card-body" style="">
          <form #cat="ngForm" (ngSubmit)="cat.form.valid && submitFormReport(cat.value)" novalidate>
           <table class="table table-hover table-bordered" style="height: 250px">
              <tbody>
              <tr>
                <td class="col6" colspan="3">
                  <div class="headerWrapper">
                    <h4>Reports</h4>
                 </div>
            
              <div class="firstColumn col-lg-12">
                <div class="col-lg-3">
                  <div class="form-group">
                    <label>Report Type</label>
                    <select
                      class="form-control"
                      data-show-content="true" id="type" #type="ngModel"
                      name="type" ngModel required [ngClass]= "{'has-danger': cat?.submitted  && type?.invalid }">
                      <option selected value="">Select Report Type</option>
                      <option value="sales_order">Sales Order Report</option>
                      <option value="invoice">Sales Invoice Report</option>
                      <option value="implant_used">Used Implants Report</option>
                      <option value="implant_rejected">Rejected Implants Report</option>
                      <option value="expiry_product">Expiry Product Report</option>
                    </select>
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="form-group">
                    <label for="Date"> From Date: </label>
                    <input type="date" placeholder="Date" class="form-control" id="start_date" name="start_date" #start_date="ngModel" ngModel
                           required [ngClass]= "{'has-danger': cat?.submitted  && start_date?.invalid }">
                  </div>
                </div>

                <div class="col-lg-3">
                  <div class="form-group">

                    <label for="Date"> To Date: </label>
                    <input type="date" placeholder="Date" class="form-control" id="end_date" name="end_date" #end_date="ngModel" ngModel
                           required [ngClass]= "{'has-danger': cat?.submitted  && end_date?.invalid }">
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="form-group">
                    <label for="Submit">&nbsp;</label>
                    <button class="form-control btn btn-success" type="submit"><i aria-hidden="true" class="fa fa-floppy-o"></i>Generate Report</button>
                  </div>
                </div>
              </div>
           
          </td></tr></tbody></table>
        </form>
          </div>
          <div class="card-body">
              <form #cat1="ngForm" (ngSubmit)="cat1.form.valid && submitFormStock(cat1.value)" novalidate>
            <table class="table table-hover table-bordered" style="height: 250px">
              <tbody>
              <tr>
                <td class="col6" colspan="3">
                  <div class="headerWrapper">
                    <h4>Stocks</h4>
                 </div>
              <div class="firstColumn col-lg-12">
                <div class="col-lg-3">
                  <div class="form-group">
                    <label>Region</label>
                    <select (change)="selectedRegion($event.target.value)" [(ngModel)]="selectedRegionM"
                            class="form-control"
                            data-show-content="true" id="selectedRegionM"
                            name="region">
                      <option selected>Select Region</option>
                      <option *ngFor="let loc of regionData; let i = index"
                              [value]="loc.id"> {{loc.name}} </option>
                    </select>
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="form-group">
                    <label> Country</label>
                    <select (change)="selectedCountry($event.target.value)" [(ngModel)]="selectedCountryM"
                            class="form-control"
                            data-show-content="true" id="selectedCountryM"
                            name="country">
                      <option selected="">Select Country</option>
                      <option *ngFor="let cou of countryData" [value]="cou.id"> {{cou.name}}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="form-group">
                    <label> City</label>
                    <select (change)="selectedCity($event.target.value)" [(ngModel)]="selectedCityM"
                            class="form-control" data-show-content="true"
                            id="selectedCityM" name="city" ngModel required [ngClass]= "{'has-danger': cat1?.submitted  && city?.invalid }">
                      <option selected="">Select City</option>
                      <option *ngFor="let ci of cityData" [value]="ci.id"> {{ci.name}} </option>
                    </select>
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="form-group">
                    <label for="Submit">&nbsp;</label>
                    <button class="form-control btn btn-success" type="submit"><i aria-hidden="true" class="fa fa-floppy-o"></i>Download  Stocks</button>
                  </div>
                </div>
                <!--
                <div class="col-lg-3">
                  <div class="form-group">
                    <label for="type">Type</label>
                    <select (change)="selectedType($event.target.value)" [(ngModel)]="selectedTypeM" class="form-control" data-show-content="true"
                            id="type"
                            name="type">
                      <option selected value="">Available</option>
                      <option value="is_billed">Billed</option>
                      <option value="is_pending">Pending</option>
                    </select>
                  </div>
                </div>
              -->
              </div>

           
                </td>

              </tr>
              </tbody>

            </table>
          </form>
          </div>

        </div>
      </div>
    
    </div>
  </div>
</div>
